import type { FunnelRouter } from "replo-publisher/src/trpc/routers/funnel";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: funnelRouter,
  client: funnelClient,
  utils: funnelUtils,
  options: funnelOptions,
} = createTrpcRouterConfig<FunnelRouter>({
  path: "funnel",
  queryClient: getNamespacedQueryClient("funnel"),
});

export { funnelClient, funnelRouter, funnelUtils, funnelOptions };
